import React from 'react';
import { feedbackText } from '../feedback-config';
import { ReactComponent as CloseCrossWhiteIcon } from '/src/assets/svg/icons/close-cross-white.svg';

interface ThankYouProps {
  onClose: () => void;
  isMobile?: boolean;
}

/** Section 5 completion screen shown after a successful submission. */
const ThankYou: React.FC<ThankYouProps> = ({ onClose, isMobile }) => (
  <div className='flex flex-col items-center px-6! py-5! text-center'>
    <h2 className={`${isMobile ? 'headline-mobile-300' : 'headline-400'} left mb-4! w-full`}>
      {feedbackText.thankYou.headline}
    </h2>
    <p className={`${isMobile ? 'text-loose-200' : 'text-tight-300'} left mb-8! `}>
      {feedbackText.thankYou.description}
    </p>
    <div className="left w-full">
    <button
      type='button'
      onClick={onClose}
      data-testid='feedback-close-thankyou'
      className={`${isMobile ? 'alt-text-tight-300-bold w-52.5' : 'alt-text-tight-400-bold w-68'} rounded-4xl max-w-xs bg-(--vel-color-secondary-500) py-3.5  text-white transition-colors hover:bg-(--vel-color-secondary-400)`}
    >
      
<CloseCrossWhiteIcon className='mr-2 inline-block text-white'/>
      {feedbackText.thankYou.close}
    </button>
    </div>
  </div>
);

export default ThankYou;
